import { ContractLogAPI } from "../api";
export class ContractLog {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getContractLog(payload) {
    const { data } = await ContractLogAPI.getContractLog(payload);
    data.result = data.result.map((item) => new ContractLog(item));
    return data.result;
  }
  static async getContractLogByContracts(payload) {
    const { data } = await ContractLogAPI.getContractLogByContracts(payload);
    data.result = data.result.map((item) => new ContractLog(item));
    return data.result;
  }

}
